import { Integrations } from '@sentry/tracing'
import { init, vueRouterInstrumentation } from '@sentry/vue'
import Vue from 'vue'
import type VueRouter from 'vue-router'

import Env from '@/env/env'
import pkg from '#/package.json'

const initSentry = (router: VueRouter): void => {
    init({
        Vue,
        dsn: Env.sentryDsn,
        environment: process.env.NODE_ENV,
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: vueRouterInstrumentation(router),
                tracingOrigins: [
                    'localhost',
                    'radio17.pl',
                    'radio17.pl.test',
                    /^\//
                ]
            })
        ],
        logErrors: true,
        maxBreadcrumbs: 50,
        release: pkg.version,
        tracesSampleRate: 0.35,
        tunnel: '/api/error-reporting'
    })
}

export {
    initSentry
}
